"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsetSessionData = exports.unsetLoadingState = exports.unsetCurrentActivity = exports.unsetActivityApplicable = exports.unsetActiveSession = exports.setSessionHeldMetrics = exports.setSessionData = exports.setSessionComplete = exports.setSessionCalendarMetrics = exports.setLoadingState = exports.setFilledSession = exports.setCurrentActivityUserLists = exports.setCurrentActivity = exports.setActivityComplete = exports.setActivityApplicable = exports.setActiveSession = exports.resetState = exports.markSessionComplete = exports.markActivityComplete = exports.initialState = exports.determineInitialSession = exports.determineInitialActivity = exports["default"] = exports.changeCurrentActivity = exports.changeActivityApplicable = exports.changeActiveSession = exports.callPostSessionRouteUnload = exports.callPostSessionRoute = exports.callPostFlowHook = exports.buildState = void 0;
var _reduxActions = require("redux-actions");
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _maxBy2 = _interopRequireDefault(require("lodash/maxBy"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdApollo = require("cccisd-apollo");
var _moment = _interopRequireDefault(require("moment"));
var _PawnList = _interopRequireDefault(require("cccisd-impact/dist/components/flowVarProcessors/PawnList.js"));
var _fixedSession = require("../selectors/fixedSession.js");
var _sendBeacon = _interopRequireDefault(require("../helpers/sendBeacon.js"));
var _allChildrenComplete = _interopRequireDefault(require("../helpers/allChildrenComplete"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; } // import _isEmpty from 'lodash/isEmpty';
var Appdefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
// Initial state
var initialState = exports.initialState = {
  loading: true,
  sessions: [],
  activeSessionId: 0,
  currentActivityHandle: ''
};

// Actions
var SET_LOADING_STATE = 'fixedSession/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'fixedSession/UNSET_LOADING_STATE';
var SET_SESSION_DATA = 'fixedSession/SET_SESSION_DATA';
var UNSET_SESSION_DATA = 'fixedSession/UNSET_SESSION_DATA';
var SET_ACTIVE_SESSION = 'fixedSession/SET_ACTIVE_SESSION';
var SET_FILLED_SESSION = 'fixedSession/SET_FILLED_SESSION';
var UNSET_ACTIVE_SESSION = 'fixedSession/UNSET_ACTIVE_SESSION';
var SET_CURRENT_ACTIVITY = 'fixedSession/SET_CURRENT_ACTIVITY';
var UNSET_CURRENT_ACTIVITY = 'fixedSession/UNSET_CURRENT_ACTIVITY';
var SET_ACTIVITY_APPLICABLE = 'fixedSession/SET_ACTIVITY_APPLICABLE';
var UNSET_ACTIVITY_APPLICABLE = 'fixedSession/UNSET_ACTIVITY_APPLICABLE';
var RESET_STATE = 'fixedSession/RESET_STATE';
var SET_ACTIVITY_COMPLETE = 'fixedSession/SET_ACTIVITY_COMPLETE';
var SET_SESSION_COMPLETE = 'fixedSession/SET_SESSION_COMPLETE';
var SET_SESSION_HELD_METRICS = 'fixedSession/SET_SESSION_HELD_METRICS';
var SET_CURRENT_ACTIVITY_USER_LISTS = 'fixedSession/SET_CURRENT_ACTIVITY_USER_LISTS';

// Action Creators
var setLoadingState = exports.setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
var unsetLoadingState = exports.unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
var setSessionData = exports.setSessionData = (0, _reduxActions.createAction)(SET_SESSION_DATA);
var unsetSessionData = exports.unsetSessionData = (0, _reduxActions.createAction)(UNSET_SESSION_DATA);
var setActiveSession = exports.setActiveSession = (0, _reduxActions.createAction)(SET_ACTIVE_SESSION);
var unsetActiveSession = exports.unsetActiveSession = (0, _reduxActions.createAction)(UNSET_ACTIVE_SESSION);
var setCurrentActivity = exports.setCurrentActivity = (0, _reduxActions.createAction)(SET_CURRENT_ACTIVITY);
var unsetCurrentActivity = exports.unsetCurrentActivity = (0, _reduxActions.createAction)(UNSET_CURRENT_ACTIVITY);
var setActivityApplicable = exports.setActivityApplicable = (0, _reduxActions.createAction)(SET_ACTIVITY_APPLICABLE);
var unsetActivityApplicable = exports.unsetActivityApplicable = (0, _reduxActions.createAction)(UNSET_ACTIVITY_APPLICABLE);
var resetState = exports.resetState = (0, _reduxActions.createAction)(RESET_STATE);
var setActivityComplete = exports.setActivityComplete = (0, _reduxActions.createAction)(SET_ACTIVITY_COMPLETE);
var setSessionComplete = exports.setSessionComplete = (0, _reduxActions.createAction)(SET_SESSION_COMPLETE);
var setSessionHeldMetrics = exports.setSessionHeldMetrics = (0, _reduxActions.createAction)(SET_SESSION_HELD_METRICS);
var setFilledSession = exports.setFilledSession = (0, _reduxActions.createAction)(SET_FILLED_SESSION);
var setCurrentActivityUserLists = exports.setCurrentActivityUserLists = (0, _reduxActions.createAction)(SET_CURRENT_ACTIVITY_USER_LISTS);

/* ***************************************************** */
/* ********************** ACTIONS ********************** */
/* ***************************************************** */

var buildState = exports.buildState = function buildState(queries, sessionData, pawn, policy) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var sessions, activeSessionResponseSet, filledActiveSession, currentActivity, currentActivityObj, formattedUserLists;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // set loading
            dispatch(setLoadingState());

            // load sessions and determine active session
            _context.next = 3;
            return getSessions(queries.getSessions, pawn, sessionData);
          case 3:
            sessions = _context.sent;
            dispatch(setSessionData(sessions));
            activeSessionResponseSet = determineInitialSession(policy, sessions);
            dispatch(setActiveSession(activeSessionResponseSet));
            _context.next = 9;
            return _fillActiveSession({
              activeSession: (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession),
              queries: queries,
              pawn: pawn
            });
          case 9:
            filledActiveSession = _context.sent;
            dispatch(setFilledSession(filledActiveSession));

            // determine current activity
            currentActivity = _getCurrent(policy, filledActiveSession.activities);
            dispatch(setCurrentActivity(currentActivity));
            currentActivityObj = (0, _fixedSession.getCurrentActivity)(getState().appdefs.fixedSession);
            if (!(currentActivityObj.acrossChildren && currentActivityObj.acrossChildrenSettings.flowUserLists)) {
              _context.next = 19;
              break;
            }
            _context.next = 17;
            return buildUserLists(currentActivityObj, pawn, currentActivityObj.acrossChildrenSettings.childrenQuery, filledActiveSession.responseSet);
          case 17:
            formattedUserLists = _context.sent;
            dispatch(setCurrentActivityUserLists(formattedUserLists));
          case 19:
            dispatch(unsetLoadingState());
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var callPostFlowHook = exports.callPostFlowHook = function callPostFlowHook(handle, data) {
  return function (dispatch, getState) {
    var appdefActivity = (0, _find2["default"])(Appdefs.sessions.fixedSettings.activities, function (activity) {
      return activity.handle === handle;
    });
    if (appdefActivity && 'postFlowRoute' in appdefActivity) {
      _cccisdAxios["default"].post(Boilerplate.route(appdefActivity.postFlowRoute), data);
    }
  };
};
var callPostSessionRouteUnload = exports.callPostSessionRouteUnload = function callPostSessionRouteUnload(data) {
  return function (dispatch, getState) {
    var activeSession = (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession);
    if ('postSessionRoute' in activeSession) {
      (0, _sendBeacon["default"])(Boilerplate.route(activeSession.postSessionRoute), data);
    }
  };
};
var callPostSessionRoute = exports.callPostSessionRoute = function callPostSessionRoute(data) {
  return function (dispatch, getState) {
    var activeSession = (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession);
    if ('postSessionRoute' in activeSession) {
      _cccisdAxios["default"].post(Boilerplate.route(activeSession.postSessionRoute), data);
    }
  };
};
var changeActiveSession = exports.changeActiveSession = function changeActiveSession(session, queries, pawn, policy) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var sessionData, filledActiveSession, currentActivity, currentActivityObj, formattedUserLists;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch(setLoadingState());
            // let newSession = _cloneDeep(session);
            dispatch(setActiveSession(session.responseSet));
            sessionData = getState().appdefs.fixedSession;
            _context2.next = 5;
            return _fillActiveSession({
              activeSession: session,
              queries: queries,
              pawn: pawn,
              sessionData: sessionData
            });
          case 5:
            filledActiveSession = _context2.sent;
            dispatch(setFilledSession(filledActiveSession));

            // build out flow lists
            // buildUserLists(filledActiveSession, pawn);

            // determine current activity
            currentActivity = _getCurrent(policy, filledActiveSession.activities);
            dispatch(setCurrentActivity(currentActivity));
            currentActivityObj = (0, _fixedSession.getCurrentActivity)(getState().appdefs.fixedSession);
            if (!(currentActivityObj.acrossChildren && currentActivityObj.acrossChildrenSettings.flowUserLists)) {
              _context2.next = 15;
              break;
            }
            _context2.next = 13;
            return buildUserLists(currentActivityObj, pawn, currentActivityObj.acrossChildrenSettings.childrenQuery, filledActiveSession.responseSet);
          case 13:
            formattedUserLists = _context2.sent;
            dispatch(setCurrentActivityUserLists(formattedUserLists));
          case 15:
            dispatch(unsetLoadingState());
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var determineInitialActivity = exports.determineInitialActivity = function determineInitialActivity(activeSession, policy) {
  return function (dispatch, getState) {
    var currentActivity = {};
    currentActivity = _getCurrent(policy, activeSession.activities);
    dispatch(setCurrentActivity(currentActivity.handle));
  };
};
var setSessionCalendarMetrics = exports.setSessionCalendarMetrics = function setSessionCalendarMetrics(metricsObj, pawn, policy) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var session, held, date, formattedDate;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            session = metricsObj.session, held = metricsObj.held, date = metricsObj.date;
            dispatch(setLoadingState());
            formattedDate = (0, _moment["default"])(date).format('MM/DD/YYYY');
            _context3.next = 5;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), {
              sourceHandle: 'impact',
              responseSet: session.responseSet,
              pawnId: pawn.pawn.pawnId,
              pawnHash: pawn.pawn.pawnHash,
              values: JSON.stringify(_defineProperty(_defineProperty({}, "".concat(session.sessionMetricsPrefix, "_held"), held ? 1 : 0), "".concat(session.sessionMetricsPrefix, "_date"), formattedDate))
            });
          case 5:
            _context3.next = 7;
            return _cccisdAxios["default"].post(Boilerplate.route('api.impact.set.current.session', {
              pawnId: pawn.pawn.pawnId
            }), {
              sessionMetricTag: "".concat(session.sessionDevTagPrefix, "Date"),
              session: session
            });
          case 7:
            dispatch(setSessionHeldMetrics({
              responseSet: session.responseSet,
              metrics: metricsObj
            }));
            dispatch(unsetLoadingState());
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var markSessionComplete = exports.markSessionComplete = function markSessionComplete(session, pawn, policy) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch(setLoadingState());
            dispatch(setSessionComplete(session.handle));
            _context4.next = 4;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), {
              sourceHandle: 'impact',
              responseSet: session.responseSet,
              pawnId: pawn.pawn.pawnId,
              pawnHash: pawn.pawn.pawnHash,
              values: JSON.stringify(_defineProperty({}, "".concat(session.sessionMetricsPrefix, "_completed"), 1))
            });
          case 4:
            dispatch(unsetLoadingState());
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var markActivityComplete = exports.markActivityComplete = function markActivityComplete(handle) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dispatch(setLoadingState());
            dispatch(setActivityComplete(handle));
            dispatch(unsetLoadingState());
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var changeCurrentActivity = exports.changeCurrentActivity = function changeCurrentActivity(activity, pawn) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState) {
      var currentActivityObj, formattedUserLists;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dispatch(setCurrentActivity(activity.handle));
            currentActivityObj = (0, _fixedSession.getCurrentActivity)(getState().appdefs.fixedSession);
            if (!(currentActivityObj.acrossChildren && currentActivityObj.acrossChildrenSettings.flowUserLists)) {
              _context6.next = 7;
              break;
            }
            _context6.next = 5;
            return buildUserLists(currentActivityObj, {
              pawn: pawn
            }, currentActivityObj.acrossChildrenSettings.childrenQuery, (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession).responseSet);
          case 5:
            formattedUserLists = _context6.sent;
            dispatch(setCurrentActivityUserLists(formattedUserLists));
          case 7:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var changeActivityApplicable = exports.changeActivityApplicable = function changeActivityApplicable(activity, applicable, pawn) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), {
              sourceHandle: 'impact',
              responseSet: (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession).responseSet,
              pawnId: pawn.pawn.pawnId,
              pawnHash: pawn.pawn.pawnHash,
              values: JSON.stringify(_defineProperty({}, activity.applicableMetricsHandle, applicable ? 1 : 0))
            });
          case 2:
            if (applicable) {
              dispatch(setActivityApplicable(activity.handle));
            } else {
              dispatch(unsetActivityApplicable(activity.handle));
            }
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x13, _x14) {
      return _ref7.apply(this, arguments);
    };
  }();
};

/* ***************************************************** */
/* ********************** HELPERS ********************** */
/* ***************************************************** */

var _getActiveSession = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(pawn, query, responseSet) {
    var variables, thaquery, result;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          variables = {
            responseSet: responseSet,
            pawnId: pawn.pawn.pawn.pawnId
          };
          thaquery = (0, _cccisdApollo.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", "\n    "])), query);
          _context8.next = 4;
          return _cccisdApollo.client.query({
            query: thaquery,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 4:
          result = _context8.sent;
          return _context8.abrupt("return", result.data);
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function _getActiveSession(_x15, _x16, _x17) {
    return _ref8.apply(this, arguments);
  };
}();
var determineInitialSession = exports.determineInitialSession = function determineInitialSession(policy, sessions) {
  var current = {};
  if (policy === 'last_incomplete') {
    var maxItem = (0, _maxBy2["default"])((0, _filter2["default"])(sessions, function (a) {
      return a.complete === true;
    }), function (o) {
      return o.responseSet;
    });
    if (maxItem === sessions[sessions.length]) {
      current = (0, _maxBy2["default"])((0, _filter2["default"])(sessions, function (a) {
        return a.complete === true;
      }), function (o) {
        return o.responseSet;
      });
    } else {
      // set to last completed session + 1
      current = sessions[(0, _findIndex2["default"])(sessions, maxItem) + 1].responseSet;
    }
  } else if (policy === 'first_incomplete') {
    // find first session where:
    // -> session is not complete AND there is no date (first session not interacted) OR
    // -> session is not complete AND the is a date AND session is held (first session interacted with that is held but not complete)
    var firstFalse = (0, _find2["default"])(sessions, function (s) {
      return s.complete === false && !s.date || s.complete === false && s.date && s.held;
    });
    if (firstFalse) {
      current = firstFalse.responseSet;
    } else {
      current = (0, _last2["default"])(sessions).responseSet;
    }
  }
  return current;
};
var _getCurrent = function _getCurrent(policy, array) {
  var current = {};
  if (policy === 'last_incomplete') {
    var maxItem = (0, _maxBy2["default"])((0, _filter2["default"])(array, function (a) {
      return a.complete === true;
    }), function (o) {
      return o.responseSet;
    });
    if (maxItem === array[array.length]) {
      current = (0, _maxBy2["default"])((0, _filter2["default"])(array, function (a) {
        return a.complete === true;
      }), function (o) {
        return o.responseSet;
      });
    } else {
      // set to last completed session + 1
      current = array[(0, _findIndex2["default"])(array, maxItem) + 1].handle;
    }
  } else if (policy === 'first_incomplete') {
    var activityProgress = (0, _find2["default"])(array, function (a) {
      return a.progress.completed === false;
    });
    if (activityProgress) {
      current = activityProgress.handle;
    } else {
      current = (0, _first2["default"])(array).handle;
    }
  }
  return current;
};
var getSessions = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(query, pawn, sessionData) {
    var variables, sortedSessions, thaquery, sessionsResponse;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          variables = {
            pawnId: pawn.pawn.pawn.pawnId
          }; // sort fields
          sortedSessions = (0, _sortBy2["default"])(sessionData, [function (f) {
            return f.order;
          }]); // get session metrics for all response sets
          thaquery = (0, _cccisdApollo.gql)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n    "])), query);
          _context9.next = 5;
          return _cccisdApollo.client.query({
            query: thaquery,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 5:
          sessionsResponse = _context9.sent;
          // set up sessionData
          sortedSessions.forEach(function (session) {
            // get data for each appdef session
            var metricsForReponseSet = (0, _find2["default"])(sessionsResponse.data.roles["".concat(pawn.role, "List")][0].metricsList, function (metric) {
              return metric.responseSet === session.responseSet;
            });
            var variableData = [];
            // Get query stuff then make query
            session.activities.forEach(function (activity) {
              var hasFlowVarData = !(0, _isNil2["default"])(activity.flowVarData);
              var queryData;
              var dataPath;
              if (hasFlowVarData) {
                var queryString = activity.flowVarData.query;
                dataPath = activity.flowVarData.dataPath;
                queryData = getVariableData(queryString, variables);
                variableData.push({
                  dataPath: dataPath,
                  queryData: queryData,
                  namePath: activity.flowVarData.namePath,
                  varHandle: activity.varHandle,
                  varProcessor: activity.flowVarProcessor
                });
              }
            });
            var formattedData = formatFlowVardata(session, variableData);
            session.varData = formattedData;

            // set held, date,

            if (metricsForReponseSet) {
              if (!(0, _isNull2["default"])(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Held")])) {
                session.held = parseInt(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Held")], 10) === 1 ? true : false;
              } else {
                session.held = false;
              }
              if (!(0, _isNull2["default"])(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Date")])) {
                session.date = metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Date")];
              } else {
                session.date = null;
              }
              if (!(0, _isNull2["default"])(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Completed")])) {
                session.complete = parseInt(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Completed")], 10) === 1 ? true : false;
              } else {
                session.complete = false;
              }
            } else {
              session.held = false;
              session.date = null;
              session.complete = false;
            }
          });

          // build flows with progress
          return _context9.abrupt("return", sortedSessions);
        case 8:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function getSessions(_x18, _x19, _x20) {
    return _ref9.apply(this, arguments);
  };
}();
var formatFlowVardata = function formatFlowVardata(session, data) {
  if (!(0, _isEmpty2["default"])(data)) {
    var response = {};
    data.forEach(function (item) {
      var formattedData = determineProcessor(item);
      formattedData.then(function (result) {
        response[result.handle] = result.data;
      });
    });
    return response;
  }
};
var determineProcessor = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(obj) {
    var processor, result, processedData;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          processor = obj.varProcessor;
          if (!(processor === 'PawnList')) {
            _context10.next = 5;
            break;
          }
          processedData = (0, _PawnList["default"])(obj);
          _context10.next = 5;
          return processedData.then(function (data) {
            result = data;
          });
        case 5:
          return _context10.abrupt("return", result);
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function determineProcessor(_x21) {
    return _ref10.apply(this, arguments);
  };
}();

// USE FOR Flow Var Query
var getVariableData = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(queryString, variables) {
    var query, result;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          query = (0, _cccisdApollo.gql)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        ", "\n    "])), queryString);
          _context11.next = 3;
          return _cccisdApollo.client.query({
            query: query,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 3:
          result = _context11.sent;
          return _context11.abrupt("return", result);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function getVariableData(_x22, _x23) {
    return _ref11.apply(this, arguments);
  };
}();
var buildUserLists = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(activity, pawn, query, responseSet) {
    var variables, thaquery, result, userListsObj;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          // run query for children
          variables = {
            parentId: pawn.pawn.pawn.pawnId,
            handle: activity.flowHandle,
            responseSet: responseSet
          };
          thaquery = (0, _cccisdApollo.gql)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", "\n    "])), query);
          _context12.next = 4;
          return _cccisdApollo.client.query({
            query: thaquery,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 4:
          result = _context12.sent;
          userListsObj = {};
          activity.acrossChildrenSettings.flowUserLists.forEach(function (userList) {
            var children = (0, _get2["default"])(result.data, userList.childrenPath);
            var processedUserList = [];
            children.forEach(function (c) {
              var processedObj = {};
              processedObj.pawnId = c.pawn.pawnId;
              processedObj.name = (0, _get2["default"])(c, userList.childTextFieldPath).toString();
              processedObj.pawnHash = c.pawn.pawnHash;
              processedUserList.push(processedObj);
            });
            userListsObj[userList.handle] = processedUserList;
          });
          return _context12.abrupt("return", userListsObj);
        case 8:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function buildUserLists(_x24, _x25, _x26, _x27) {
    return _ref12.apply(this, arguments);
  };
}();
var _fillActiveSession = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref13) {
    var activeSession, queries, pawn, sessionData, flowProgressResponse, metricResponseItem;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          activeSession = _ref13.activeSession, queries = _ref13.queries, pawn = _ref13.pawn, sessionData = _ref13.sessionData;
          _context13.next = 3;
          return _getActiveSession(pawn, queries.getSession, activeSession.responseSet);
        case 3:
          flowProgressResponse = _context13.sent;
          // map flowprogresslist to session activities
          if (flowProgressResponse.roles["".concat(pawn.role, "List")][0].flowProgressList.length > 0) {
            activeSession.activities.forEach(function (activity) {
              var activityProgress = (0, _find2["default"])(flowProgressResponse.roles["".concat(pawn.role, "List")][0].flowProgressList, function (fp) {
                return activity.flowHandle === fp.flowHandle;
              });
              var matchingAppdefActivity = (0, _find2["default"])(Appdefs.sessions.fixedSettings.activities, function (a) {
                return a.handle === activity.handle;
              });
              if (activityProgress) {
                // use matching progress from query
                activity.progress = (0, _omit2["default"])(activityProgress, ['flowHandle']);
              } else if ('acrossChildren' in activity && !('flowUserLists' in activity.acrossChildrenSettings)) {
                if (sessionData) {
                  var sessions = sessionData.sessions;
                  var sessionMatch = (0, _find2["default"])(sessions, function (s) {
                    return s.responseSet === activeSession.responseSet;
                  });
                  if (sessionMatch) {
                    var activityMatch = (0, _find2["default"])(sessionMatch.activities, function (a) {
                      return a.handle === activity.handle;
                    });
                    if (activityMatch.progress) {
                      activity.progress = activityMatch.progress;
                    } else {
                      activity.progress = {
                        started: false,
                        completed: false
                      };
                    }
                  } else {
                    activity.progress = {
                      started: false,
                      completed: false
                    };
                  }
                } else if ((0, _allChildrenComplete["default"])(activity, pawn.pawn, activeSession)) {
                  activity.progress = {
                    started: true,
                    completed: true
                  };
                } else {
                  activity.progress = {
                    started: false,
                    completed: false
                  };
                }
              } else {
                activity.progress = {
                  started: false,
                  completed: false
                };
              }
              if ('applicableMetricsHandle' in matchingAppdefActivity && 'source' in matchingAppdefActivity) {
                var applicableMetric = (0, _find2["default"])((0, _find2["default"])(Appdefs.metrics.sources, function (s) {
                  return matchingAppdefActivity.source === s.name;
                }).metrics, function (m) {
                  return m.name === matchingAppdefActivity.applicableMetricsHandle;
                });
                if (applicableMetric.defaultValue) {
                  activity.applicable = true;
                } else {
                  activity.applicable = false;
                }
              } else {
                activity.applicable = true;
              }
            });
          } else {
            activeSession.activities.forEach(function (a) {
              a.progress = {
                started: false,
                completed: false
              };
              var matchingAppdefActivity = (0, _find2["default"])(Appdefs.sessions.fixedSettings.activities, function (appdefActivity) {
                return a.handle === appdefActivity.handle;
              });
              if ('applicableMetricsHandle' in matchingAppdefActivity && 'source' in matchingAppdefActivity) {
                var applicableMetric = (0, _find2["default"])((0, _find2["default"])(Appdefs.metrics.sources, function (s) {
                  return matchingAppdefActivity.source === s.name;
                }).metrics, function (m) {
                  return m.name === matchingAppdefActivity.applicableMetricsHandle;
                });
                if (applicableMetric.defaultValue) {
                  a.applicable = true;
                } else {
                  a.applicable = false;
                }
              } else {
                a.applicable = true;
              }
            });
          }
          if (flowProgressResponse.roles["".concat(pawn.role, "List")][0].metricsList && flowProgressResponse.roles["".concat(pawn.role, "List")][0].metricsList.length > 0) {
            metricResponseItem = (0, _find2["default"])(flowProgressResponse.roles["".concat(pawn.role, "List")][0].metricsList, function (metric) {
              return metric.responseSet === activeSession.responseSet;
            });
            if (metricResponseItem && metricResponseItem.devTags) {
              activeSession.activities.forEach(function (activity) {
                var matchingAppdefActivity = (0, _find2["default"])(Appdefs.sessions.fixedSettings.activities, function (appdefActivity) {
                  return activity.handle === appdefActivity.handle;
                });
                if ('applicableMetricsHandle' in matchingAppdefActivity && 'source' in matchingAppdefActivity) {
                  var applicableMetric = (0, _find2["default"])((0, _find2["default"])(Appdefs.metrics.sources, function (s) {
                    return matchingAppdefActivity.source === s.name;
                  }).metrics, function (m) {
                    return m.name === matchingAppdefActivity.applicableMetricsHandle;
                  });
                  if (!(0, _isNull2["default"])(metricResponseItem.devTags[(0, _first2["default"])(applicableMetric.tags)])) {
                    activity.applicable = _findBoolean(metricResponseItem.devTags[(0, _first2["default"])(applicableMetric.tags)]);
                  }
                }
              });
            }
          }
          return _context13.abrupt("return", activeSession);
        case 7:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function _fillActiveSession(_x28) {
    return _ref14.apply(this, arguments);
  };
}();
var _findBoolean = function _findBoolean(value) {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  if (value === '1') {
    return true;
  }
  if (value === '0') {
    return false;
  }
  if (value) {
    return true;
  }
  if (!value) {
    return false;
  }
};

// Reducers
var _default = exports["default"] = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), SET_SESSION_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: action.payload
  });
}), UNSET_SESSION_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: []
  });
}), SET_ACTIVE_SESSION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeSessionId: action.payload
  });
}), UNSET_ACTIVE_SESSION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeSessionId: 0
  });
}), SET_CURRENT_ACTIVITY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentActivityHandle: action.payload
  });
}), UNSET_CURRENT_ACTIVITY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentActivityHandle: ''
  });
}), SET_ACTIVITY_APPLICABLE, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var activeSession = (0, _fixedSession.getActiveSession)(state);
  var existingActiveSession = (0, _find2["default"])(newSessions, function (ns) {
    return ns.responseSet === activeSession.responseSet;
  });
  var activity = (0, _find2["default"])(existingActiveSession.activities, function (a) {
    return a.handle === action.payload;
  });
  activity.applicable = true;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), UNSET_ACTIVITY_APPLICABLE, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var activeSession = (0, _fixedSession.getActiveSession)(state);
  var existingActiveSession = (0, _find2["default"])(newSessions, function (ns) {
    return ns.responseSet === activeSession.responseSet;
  });
  var activity = (0, _find2["default"])(existingActiveSession.activities, function (a) {
    return a.handle === action.payload;
  });
  activity.applicable = false;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, RESET_STATE, function (state, action) {
  return {
    loading: true,
    sessions: [],
    activeSessionId: 0,
    currentActivityHandle: ''
  };
}), SET_ACTIVITY_COMPLETE, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var activeSession = (0, _fixedSession.getActiveSession)(state);
  var existingActiveSession = (0, _find2["default"])(newSessions, function (ns) {
    return ns.responseSet === activeSession.responseSet;
  });
  var activity = (0, _find2["default"])(existingActiveSession.activities, function (a) {
    return a.handle === action.payload;
  });
  activity.progress.started = true;
  activity.progress.completed = true;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), SET_SESSION_COMPLETE, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var session = (0, _find2["default"])(newSessions, function (a) {
    return a.handle === action.payload;
  });
  session.complete = true;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), SET_SESSION_HELD_METRICS, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var session = (0, _find2["default"])(newSessions, function (s) {
    return s.responseSet === action.payload.responseSet;
  });
  session.held = action.payload.metrics.held;
  session.date = action.payload.metrics.date;
  session.complete = action.payload.metrics.complete;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), SET_FILLED_SESSION, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var sessionIndex = (0, _findIndex2["default"])(newSessions, function (s) {
    return s.responseSet === action.payload.responseSet;
  });
  newSessions[sessionIndex] = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), SET_CURRENT_ACTIVITY_USER_LISTS, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var activeSession = (0, _fixedSession.getActiveSession)(state);
  var existingActiveSession = (0, _find2["default"])(newSessions, function (ns) {
    return ns.responseSet === activeSession.responseSet;
  });
  var activity = (0, _find2["default"])(existingActiveSession.activities, function (a) {
    return a.handle === state.currentActivityHandle;
  });
  activity.acrossChildrenSettings.formattedFlowUserLists = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
})), initialState);